import styled from "styled-components";

export const SkillSection = styled.section`

    background-color: white;
    max-width: 1200px;
    margin: 0 auto;

    .divUl {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
    }

    .ulList {
        
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 500px;
        flex-wrap: wrap;
    }

    .left {
        display: grid;
        grid-template-columns: auto auto;

        margin-bottom: 115px;

        width: auto;
    }

    @media (min-width: 780px) {
        
        height: 100vh;

        .divUl{
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-around;
        }

        .ulList{
            width: none;
        }

        .left {
            display: flex;
        }
    }

`